import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { privateCompaniesManager } from '@inpart-io/padme-iap';
import { type IPrivateCompany } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const PRIVATE_COMPANY_MODULE = 'privateCompany';

const state = { matches: new Map() };

const dataObjectModule = getDataObjectsModule<IPrivateCompany>(privateCompaniesManager, 3);
const searchModule = getSearchModule<IPrivateCompany>(privateCompaniesManager);

const privateCompanyModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, getters, mutations });
store.registerModule(PRIVATE_COMPANY_MODULE, privateCompanyModuleInstance);

export { PRIVATE_COMPANY_MODULE };
